// Storage keys and request header for the admin "view as coach" feature. Shared
// so the user store and the axios interceptor never drift - a mismatch would
// silently stop the acting-coach header from being sent.
export const ACTING_COACH_ID_KEY = 'actingCoachId'
export const ACTING_COACH_NAME_KEY = 'actingCoachName'
export const ACTING_COACH_HEADER = 'X-Acting-Coach-Id'
